"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function yearFact(dataset, name) {
    return {
        name,
        tableType: 'fact',
        grain: [
            dataset + '::key',
            'year::key'
        ],
        tableGrain: [
            '!' + dataset,
            'year_key'
        ],
        foreignKeys: [
            dataset + '::key'
        ]
    };
}
function orgFact(name) {
    return yearFact('org', name);
}
const org = {
    name: 'org',
    tableType: 'dim',
    grain: [
        '::id',
        '::key'
    ],
    tableGrain: ['!org'],
    foreignKeys: [],
    facts: [
        '@orgs',
        'health-system-market-share-cbsa',
        'health-system-market-share-county',
        'health-system-market-share-state'
    ]
};
const affiliatedOrg = Object.assign({ ...org }, { name: 'affiliated-org' });
const subSystem = {
    name: 'subsystem',
    tableType: 'dim',
    grain: [
        '::key'
    ],
    tableGrain: [
        '!subsystem'
    ],
    foreignKeys: [
        'state::key',
        'health-system::id'
    ]
};
const orgAllPatientsDaysTripsVisits = orgFact('org-all-patients-days-trips-visits');
const orgBedDays = orgFact('org-bed-days');
const orgBeds = orgFact('org-beds');
const orgCAH = orgFact('org-cah');
const orgCapitalAccounts = orgFact('org-capital-accounts');
const orgCost = orgFact('org-cost');
const orgDischarges = orgFact('org-discharges');
const orgFullTimeEquivalents = orgFact('org-full-time-equivalents');
const orgHHCostReportFinancials = orgFact('org-hh-cost-report-financials');
const orgHHCostReportFTE = orgFact('org-hh-cost-report-fte');
const orgHHCostReportPatients = orgFact('org-hh-cost-report-patients');
const orgHHCostReportVisits = orgFact('org-hh-cost-report-visits');
const orgHospiceCostReportCostOfCare = orgFact('org-hospice-cost-report-cost-of-care');
const orgHospiceCostReportDays = orgFact('org-hospice-cost-report-days');
const orgHospiceCostReportRevenue = orgFact('org-hospice-cost-report-revenue');
const orgHospiceCostReportSalaries = orgFact('org-hospice-cost-report-salaries');
const orgIncome = orgFact('org-income');
const orgInpatientRevenue = orgFact('org-inpatient-revenue');
const orgOutpatientRevenue = orgFact('org-outpatient-revenue');
const orgOverhead = orgFact('org-overhead');
const orgSNFCostReportAdmissions = orgFact('org-snf-cost-report-admissions');
const orgSNFCostReportBeds = orgFact('org-snf-cost-report-beds');
const orgSNFCostReportDays = orgFact('org-snf-cost-report-days');
const orgSNFCostReportDischarges = orgFact('org-snf-cost-report-discharges');
const orgSNFCostReportFinancials = orgFact('org-snf-cost-report-financials');
const orgSNFCostReportFTEs = orgFact('org-snf-cost-report-ftes');
const orgTitleVDaysTripsVisits = orgFact('org-title-v-days-trips-visits');
const orgTitleXIXDaysTripsVisits = orgFact('org-title-xix-days-trips-visits');
const orgTitleXVIIIDaysTripsVisits = orgFact('org-title-xviii-days-trips-visits');
const orgTotalFundAssets = orgFact('org-total-fund-assets');
const orgTotalRevenue = orgFact('org-total-revenue');
const orgWages = orgFact('org-wages');
exports.default = [
    org,
    affiliatedOrg,
    subSystem,
    orgAllPatientsDaysTripsVisits,
    orgBedDays,
    orgBeds,
    orgCAH,
    orgCapitalAccounts,
    orgCost,
    orgDischarges,
    orgFullTimeEquivalents,
    orgHHCostReportFinancials,
    orgHHCostReportFTE,
    orgHHCostReportPatients,
    orgHHCostReportVisits,
    orgHospiceCostReportCostOfCare,
    orgHospiceCostReportDays,
    orgHospiceCostReportRevenue,
    orgHospiceCostReportSalaries,
    orgIncome,
    orgInpatientRevenue,
    orgOutpatientRevenue,
    orgOverhead,
    orgSNFCostReportAdmissions,
    orgSNFCostReportBeds,
    orgSNFCostReportDays,
    orgSNFCostReportDischarges,
    orgSNFCostReportFinancials,
    orgSNFCostReportFTEs,
    orgTitleVDaysTripsVisits,
    orgTitleXIXDaysTripsVisits,
    orgTitleXVIIIDaysTripsVisits,
    orgTotalFundAssets,
    orgTotalRevenue,
    orgWages
];
